import React from "react";
import { makeIcon } from "components/ui/Icon";

export const SensitivityIcon = makeIcon(
	<svg viewBox="0 0 16 16" fill="none">
		<circle cx="8" cy="8" r="7" fill="currentColor" />
	</svg>
);
